import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from './Routes/Routes';
import AOS from 'aos'; 
import { useEffect } from 'react';
import Particle from './components/Particle/Particle';
function App() {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
    });
  }, [])
  
  return (
   <>
   
   <Particle/>   
   <RouterProvider router={router}></RouterProvider>
   </>
    
  );
}

export default App;
